import moment from "moment";
import { METODI_PAGAMENTO, nomeMetodoPagamento } from "./metodoPagamento";
export default {
  props: {
    contabile: Object,
  },
  data() {
    return {
      dialog: false,
      verde: this.contabile.verde,
      importo: Math.abs(this.contabile.importo).toFixed(2),
      menu_data: false,
      date: moment.unix(this.contabile.ts).format("YYYY-MM-DD"),
      items_tipo: [
        { id: 1, tipo: "Debito" },
        { id: 2, tipo: "Pagamento Cliente" },
      ],
      tipo: this.contabile.tipo,
      ordine: null,
      subordine: null,
      listaOrdini: [],
      ddt: this.contabile.ddt,
      note: this.contabile.note,
      loadingSalva: false,
      loadingOrdine: true,
      errorDialog: false,
      errorMessage: null,
      valid: false,
      // Metodo di pagamento (solo tipo=2) e imponibile erodibile (solo
      // tipo=3): non esisteva modo di correggerli dopo la creazione.
      metodoPagamento: this.contabile.metodo_pagamento,
      metodiPagamento: METODI_PAGAMENTO,
      importoImponibile: this.contabile.importo_imponibile,
      // Storico Allocazioni di questo contabile (sia come debito coperto
      // sia come credito eroso/consumato): serve per bloccare la modifica
      // di importo/tipo/verde/imponibile quando ci sono già coperture
      // collegate, altrimenti si romperebbero in modo silenzioso i
      // residui/vincoli già calcolati altrove (vedi update_contabile).
      // Finché non è caricato si assume "bloccato" per prudenza, non il
      // contrario: niente flash di campi editabili poi ri-disabilitati.
      loadingCoperture: true,
      comeDebito: [],
      comeCredito: [],
      importoBaseCredito: null,
      residuoCredito: null,
    };
  },
  mounted() {
    if (this.contabile) {
      this.ordine = this.contabile.id_ordine;
      if (this.contabile.id_subconteggio) {
        this.subordine = this.contabile.id_subconteggio;
      }
    }
  },
  computed: {
    cliente() {
      return this.$store.getters.get_cliente_by_iva(this.contabile.cliente);
    },
    dataFormatted() {
      return moment(this.date).format("dddd DD MMMM YYYY");
    },
    subConteggi() {
      let ordine = this.$store.getters.get_ordine_by_id(this.ordine);
      if (ordine) {
        if(ordine.subConteggio === undefined){
          return [];
        }
        return ordine.subConteggio.map((sub) => ({
          id: sub.id.$oid,
          numero: sub.subNumero,
        }));
      } else {
        return [];
      }
    },
    // Vero se questo contabile ha già almeno un'Allocazione collegata, in
    // qualunque direzione (coperto come debito, oppure usato come fonte di
    // copertura/erosione per un debito altrui).
    haCoperture() {
      return this.comeDebito.length > 0 || this.comeCredito.length > 0;
    },
    bloccaImportoTipoVerde() {
      return this.loadingCoperture || this.haCoperture;
    },
    // L'imponibile di una Fattura Anticipata è modificabile solo se nessun
    // debito l'ha ancora eroso (altrimenti la base persistita si
    // scollerebbe dal residuo già consumato).
    bloccaImponibile() {
      return this.loadingCoperture || this.comeCredito.length > 0;
    },
  },
  watch: {
    verde() {
      this.ddt = null;
    },
    dialog: function () {
      if (this.dialog) {
        this.loadingOrdine = true;
        this.$store
          .dispatch("fetch_ordini_by_cliente", this.contabile.cliente)
          .then((ordini) => {
            this.listaOrdini = [
              { numero: "Nessun ordine", "_id.$oid": "" },
              ...ordini,
            ];
          })
          .finally(() => {
            this.loadingOrdine = false;
          });

        this.loadingCoperture = true;
        this.$store
          .dispatch("fetch_allocazioni_contabile", this.contabile.id)
          .then((dati) => {
            this.comeDebito = dati.come_debito || [];
            this.comeCredito = dati.come_credito || [];
            this.importoBaseCredito = dati.importo_base ?? null;
            this.residuoCredito = dati.residuo ?? null;
          })
          .catch(() => {
            // Prudenza: se il caricamento fallisce, resta bloccato
            // (bloccaImportoTipoVerde dipende comunque da loadingCoperture
            // finché non lo forziamo a false qui sotto) — meglio negare
            // una modifica legittima che rischiare di corromperne una.
          })
          .finally(() => {
            this.loadingCoperture = false;
          });
      }
    },
  },
  methods: {
    nomeMetodo(value) {
      return nomeMetodoPagamento(value);
    },
    salvaContabile() {
      this.loadingSalva = true;
      this.errorMessage = null;
      this.$store
        .dispatch("update_contabile", {
          id: this.contabile.id,
          verde: this.verde,
          importo: this.tipo == 1 || this.tipo == 3 ? this.importo : -this.importo,
          ts: moment(this.date).format("X"),
          tipo: this.tipo,
          id_ordine: this.ordine,
          id_subconteggio: this.contabile.id_subconteggio,
          ddt: this.ddt,
          note: this.note,
          // Solo per tipo=2 (Pagamento Cliente): correzione del metodo di
          // pagamento indicato in creazione.
          metodo_pagamento: this.tipo == 2 || this.tipo == 3 ? this.metodoPagamento : null,
          // Solo per tipo=3 (Fattura Anticipata), e solo se non ancora
          // eroso da nessun debito (vedi bloccaImponibile): l'imponibile
          // persistito per il calcolo del residuo erodibile.
          importo_imponibile:
            this.tipo == 3 && !this.bloccaImponibile ? this.importoImponibile : null,
        })
        .then(() => {
          this.loadingSalva = false;
          this.dialog = false;
          this.$emit("update-contabile");
        })
        .catch((err) => {
          this.loadingSalva = false;
          this.errorMessage = err.response?.data?.message || null;
          this.errorDialog = true;
          setTimeout(() => {
            this.errorDialog = false;
          }, 3000);
        });
    },
  },
};
